import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import gratitudeSpinner from 'assets/images/gratitude_spinner.svg';
import {SkeletonFadeIn} from 'components/DSYS/SkeletonFadeIn';
import {ROUTE_PATHS} from 'constant';
import {t} from 'i18next';
import {useNavigate} from 'react-router';
import {logDashboardInteraction} from 'views/home/dashboard/dashboardAnalytics';
import {DashboardState} from 'views/home/dashboard/dashboardModel';
import {Tile} from 'views/home/dashboard/Tile';

import styles from './GratitudeTile.module.css';

export const GratitudeTile = ({state}: {state: DashboardState}) => {
  const navigate = useNavigate();
  const gratitude = state.latestGratitude;

  return (
    <Tile
      bare
      className={styles.gratitudeTile}
      onClick={() => {
        logDashboardInteraction({action: 'tile_click', tileId: 'gratitude'});
        navigate(ROUTE_PATHS.GRATITUDE_BROWSE);
      }}
    >
      <img className={styles.gratitudeSpinner} src={gratitudeSpinner} alt="" aria-hidden />
      <Stack gap="12" style={{height: '100%', position: 'relative'}}>
        <span className={styles.gratitudeWordmark}>{t('dashboard_tile_gratitude')}</span>
        <SkeletonFadeIn
          loading={state.gratitudeLoading}
          skeleton={
            <Stack gap="6">
              <Skeleton.Text width={200} />
              <Skeleton.Text size="small" width={100} />
            </Stack>
          }
        >
          {gratitude ? (
            <Stack gap="6">
              <Text style={{color: 'inherit'}}>&ldquo;{gratitude.message}&rdquo;</Text>
              <Text style={{color: 'inherit', opacity: 0.85}}>— {gratitude.senderName}</Text>
            </Stack>
          ) : (
            <Text style={{color: 'inherit'}}>{t('dashboard_gratitude_empty_cta')}</Text>
          )}
        </SkeletonFadeIn>
      </Stack>
    </Tile>
  );
};
